<template>
  <div :key="keyCounter">
    <template v-if="findElement(topLevelId, 'category')">
      <b-menu-item
        v-for="(level, index) of findElement(topLevelId, 'category')"
        :key="level.id"
        :active="isActive[index]"
        :expanded="isActive[index]"
        @click="toggle(index)"
      >
        <template #label
          ><b-icon :icon="isActive[index] ? 'chevron-down' : 'chevron-right'" size="is-small"></b-icon>
          {{ level.name }}
        </template>
        <TreeItemDrillDown
          :route="route"
          :tree="tree"
          :topLevelId="level.id"
          @selectItem="selectItem"
        ></TreeItemDrillDown>
      </b-menu-item>
    </template>
    <template v-if="findElement(topLevelId, 'indicator')">
      <template v-if="route">
        <router-link
          v-for="level of findElement(topLevelId, 'indicator')"
          class="is-size-6"
          :key="level.id"
          :to="{ name: route, params: { id: level.id } }"
          append
          ><b-icon icon="table-large" size="is-small"></b-icon>
          {{ level.name }}
        </router-link>
      </template>
      <template v-else>
        <b-menu-item v-for="level of findElement(topLevelId, 'indicator')" :key="level.id" @click="selectItem(level)">
          <template #label><b-icon icon="table-large" size="is-small"></b-icon> {{ level.name }}</template>
        </b-menu-item>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    route: {
      type: String
    },
    tree: {
      type: Array,
      required: true
    },
    topLevelId: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    TreeItemDrillDown: () =>
      import(/* webpackChunkName: "TreeItemDrillDown" */ '@/components/shared/TreeItemDrillDown.vue')
  },
  data() {
    return {
      isActive: [],
      keyCounter: 0
    };
  },
  mounted() {
    this.isActive = this.findElement(this.topLevelId, 'category').map(el => false);
  },
  methods: {
    selectItem(item) {
      this.$emit('selectItem', item);
    },

    toggle(index) {
      let activeList = [];

      for (let i = 0; i < this.isActive.length; i++) {
        let value;

        if (i === index) {
          value = !this.isActive[i];
        }

        activeList.push(value);
      }

      this.isActive = activeList;
      this.keyCounter++;
    },

    findElement(id, type) {
      return this.tree.filter(el => el.parent_id === id && el.type === type);
    }
  }
};
</script>

<style lang="scss" scoped></style>
